import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import {
    GoogleOutlined,
    GithubOutlined,
} from "@ant-design/icons";
import { Logo } from "../../components/Logo";
import "./AuthPage.css";

const AuthPage: React.FC = () => {
    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            const endpoint = isLogin ? "/api/auth/login" : "/api/auth/register";
            const payload = isLogin
                ? { email, password }
                : { email, password, name, acceptTerms: true };

            const response = await fetch(`http://localhost:4000${endpoint}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data.success) {
                localStorage.setItem("access_token", data.token);
                if (data.refreshToken) {
                    localStorage.setItem("refresh_token", data.refreshToken);
                }
                message.success(isLogin ? "Welcome back!" : "Account created successfully!");

                // Redirect to dashboard after short delay to show success message
                setTimeout(() => {
                    navigate("/dashboard");
                }, 1000);
            } else {
                message.error(data.message || "Authentication failed");
            }
        } catch (error) {
            message.error("Network error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleAuth = () => {
        window.location.href = "http://localhost:4000/api/auth/google";
    };

    return (
        <div className="auth-container">
            {/* Animated background */}
            <div className="auth-bg">
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
            </div>

            {/* Glassmorphism card */}
            <div className="auth-card">
                <div className="auth-header">
                    <div className="auth-logo">
                        <Logo />
                    </div>
                    <p className="auth-tagline">Expedient</p>
                </div>

                {/* Tab switcher */}
                <div className="auth-tabs">
                    <button
                        className={`auth-tab ${isLogin ? "active" : ""}`}
                        onClick={() => setIsLogin(true)}
                    >
                        LOGIN
                    </button>
                    <button
                        className={`auth-tab ${!isLogin ? "active" : ""}`}
                        onClick={() => setIsLogin(false)}
                    >
                        REGISTER
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {!isLogin && (
                        <div className="input-group">
                            <label htmlFor="name">Full Name</label>
                            <input
                                id="name"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="John Doe"
                                required={!isLogin}
                                className="auth-input"
                            />
                        </div>
                    )}

                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            required
                            className="auth-input"
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                            className="auth-input"
                        />
                    </div>

                    <button
                        type="submit"
                        className="auth-submit"
                        disabled={loading}
                    >
                        {loading ? "PROCESSING..." : isLogin ? "LOGIN" : "CREATE ACCOUNT"}
                    </button>
                </form>

                {/* Divider */}
                <div className="auth-divider">
                    <span>OR</span>
                </div>

                {/* OAuth buttons */}
                <div className="auth-oauth">
                    <button
                        type="button"
                        onClick={handleGoogleAuth}
                        className="oauth-button google"
                    >
                        <GoogleOutlined />
                        <span>Continue with Google</span>
                    </button>

                    <button
                        type="button"
                        className="oauth-button github"
                        disabled
                    >
                        <GithubOutlined />
                        <span>GitHub (Coming Soon)</span>
                    </button>
                </div>

                {/* Footer */}
                <div className="auth-footer">
                    <p style={{ marginBottom: '8px' }}>
                        By continuing, you agree to our{" "}
                        <a href="/terms">Terms</a> and <a href="/privacy">Privacy Policy</a>
                    </p>
                    <p style={{ fontSize: '11px', color: '#52525b', margin: 0 }}>
                        © {new Date().getFullYear()} Expedient. All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AuthPage;